export class CompanySsoInfoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanySsoInfo() {
    return this.#http.get('/CompanySsoInfo');
  }

  async getCompanySsoInfoInternal({ companyId }) {
    return this.#http.get(`/CompanySsoInfo/internal/${companyId}`);
  }

  async getCompanySsoInfoProviderInfo() {
    return this.#http.get(`/CompanySsoInfo/providerInfo`);
  }

  async getCompanySsoInfoProviderInfoInternal({ companyId }) {
    return this.#http.get(`/CompanySsoInfo/internal/${companyId}/providerInfo`);
  }

  async createCompanySsoInfo(body) {
    return this.#http.post('/CompanySsoInfo', body);
  }

  async createCompanySsoInfoInternal(body) {
    return this.#http.post('/CompanySsoInfo/internal', body);
  }

  async deleteCompanySsoInfo() {
    return this.#http.delete('/CompanySsoInfo');
  }

  async deleteCompanySsoInfoInternal({ id }) {
    return this.#http.delete(`/CompanySsoInfo/internal/${id}`);
  }
}
